"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OnGraphicsComponentAdded = void 0;
/**
 * @public
 * Emitted on graphics component added to chart.
 */
class OnGraphicsComponentAdded {
    constructor(onGraphicsComponentAdded) {
        this.onGraphicsComponentAdded = onGraphicsComponentAdded;
    }
    static registerListener(chartEventService, onEvent) {
        return chartEventService
            .getCategory(OnGraphicsComponentAdded)
            .addTemporaryListener(new OnGraphicsComponentAdded(onEvent));
    }
    static emit(chartEventService, graphicsComponent) {
        const listeners = chartEventService
            .getCategory(OnGraphicsComponentAdded)
            .getTargets();
        for (let i = 0, iEnd = listeners.length; i < iEnd; ++i) {
            listeners[i].onGraphicsComponentAdded(graphicsComponent);
        }
    }
}
exports.OnGraphicsComponentAdded = OnGraphicsComponentAdded;
OnGraphicsComponentAdded.callbackKey = "onGraphicsComponentAdded";
//# sourceMappingURL=on-graphics-component-added.js.map